import { render, staticRenderFns } from "./AdminDoctorListing.vue?vue&type=template&id=5b44c260"
import script from "./AdminDoctorListing.vue?vue&type=script&lang=js"
export * from "./AdminDoctorListing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports